import axios from 'axios';
import { API_BASE_URL } from './config';

const authConfig = {
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' }
};

const getAllContacts = async () => {
    const response = await axios.get(`${API_BASE_URL}/kontakte`, authConfig);
    return response.data;
};

const getUserContacts = async (userId) => {
    const response = await axios.get(`${API_BASE_URL}/kontakte/user/${userId}`, authConfig);
    return response.data;
};

const createContact = async (contactData) => {
    const response = await axios.post(`${API_BASE_URL}/kontakte`, contactData, authConfig);
    return response.data;
};

const updateContact = async (id, contactData) => {
    const response = await axios.put(`${API_BASE_URL}/kontakte/${id}`, contactData, authConfig);
    return response.data;
};

const deleteContact = async (id) => {
    const response = await axios.delete(`${API_BASE_URL}/kontakte/${id}`, authConfig);
    return response.data;
};

export {
    getAllContacts,
    getUserContacts,
    createContact,
    updateContact,
    deleteContact
};
